import { Card, Col, Row } from 'antd'
import React from 'react'
import { FaChevronLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import BusinessProof from './BusinessProof'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'

const VerifyBusiness = () => {
    return (
        <Row>
            <TitleWithBackNavigation title={'Verify Business'} link={'/settings'} />
            <Card bordered={false} className='p-0 my-3 w-full'>
                <BusinessProof />
            </Card>
        </Row>
    )
}

export default VerifyBusiness